__turbopack_context__.v({
  "background": "modal-background-module-scss-module__Xo3JLa__background",
  "subtle": "modal-background-module-scss-module__Xo3JLa__subtle",
  "transparent": "modal-background-module-scss-module__Xo3JLa__transparent",
});
